import { ReactNode, useMemo } from 'react';

import createSafeContext from '#/utils/createSafeContext';

import {
  MarketsStoreView,
  usePerpetualMarketsStoreView,
} from '#/features/perpetuals/market-info/markets-context';
import { PerpetualMarket } from '#/api/markets';

export interface FuturesActiveMarketStoreView {
  readonly activeMarket: PerpetualMarket | null;
}

export const [useFuturesActiveMarketStoreView, StoreViewProvider] =
  createSafeContext<FuturesActiveMarketStoreView>(
    'FuturesActiveMarketStoreView',
  );

interface Props {
  readonly symbol: string | null;
  readonly children: ReactNode;
}

export function FuturesActiveMarketProvider(props: Props) {
  const marketsStoreView = usePerpetualMarketsStoreView();

  const storeView = useMemo(
    () => deriveStoreView(marketsStoreView, props.symbol),
    [marketsStoreView, props.symbol],
  );

  return (
    <StoreViewProvider value={storeView}>{props.children}</StoreViewProvider>
  );
}

export function deriveStoreView(
  marketsStoreView: MarketsStoreView,
  symbol: string | null,
): FuturesActiveMarketStoreView {
  const activeMarket = deriveActiveMarket(marketsStoreView, symbol);

  return {
    activeMarket,
  };
}

function deriveActiveMarket(
  storeView: MarketsStoreView,
  symbol: string | null,
): FuturesActiveMarketStoreView['activeMarket'] {
  if (symbol == null) return null;
  const activeMarket = storeView.getMarket(symbol);

  return activeMarket ?? null;
}
